import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLogin: false,
    username: "",
    volunteer_info: 0, // 是否报名
    have_award: 0, // 是否获奖 1是0否
    express: 0, // 是否已填写快递信息 1时0否
    title: '',
    desc: '',
    time: new Date(),
    sid: undefined,
    category_id: undefined,
    topic_id: undefined
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
  getters: {
    getUserInfo(state) {
      const info = {
        isLogin: state.isLogin,
        username: state.username,
        volunteer_info: state.volunteer_info,
        have_award: state.have_award,
        express: state.express
      };
      return info;
    },
    getPicWorkInfo(state) {
      const info = {
        title: state.title,
        desc: state.desc,
        time: state.time,
        sid: state.sid,
        category_id: state.category_id,
        topic_id: state.topic_id
      };
      return info;
    },
  },
  mutations: {
    setUserInfo(state, userinfo) {
      state.isLogin = userinfo.isLogin;
      state.username = userinfo.username;
      state.volunteer_info = userinfo.volunteer_info;
      state.express = userinfo.express;
      state.have_award = userinfo.have_award
    },
    setPicWorkInfo(state, workInfo) {
      state.title = workInfo.title
      state.desc = workInfo.desc
      state.time = workInfo.time
      state.sid = workInfo.sid
      state.category_id = workInfo.category_id
      state.topic_id = workInfo.topic_id
    },
  },
  actions: {
    setUserInfoAction(context, info) {
      context.commit("setUserInfo", info);
    },
    setPicWorkInfoAction(context, info) {
      context.commit("setPicWorkInfo", info);
    },
  },
});
